module.exports = __webpack_public_path__ + "img/logo-auth.444f4ad5.svg";